import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import AppFooter from 'components/AppFooter';
import FishingGame from './components/FishingGame';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: '4em',
    paddingRight: '4em',
    [theme.breakpoints.only('md')]: {
      paddingLeft: '4em',
      paddingRight: '4em',
    },
    [theme.breakpoints.only('sm')]: {
      paddingTop: '2em',
      paddingLeft: '6em',
      paddingRight: '6em',
    },
    [theme.breakpoints.only('xs')]: {
      paddingTop: '1.5em',
      paddingLeft: '2em',
      paddingRight: '2em',
    },
  },
}));

const Games = () => {
  const styles = useStyles();

  return (
    <React.Fragment>
      <Grid container direction="column" className={styles.root}>
        <FishingGame />
      </Grid>
      <AppFooter />
    </React.Fragment>
  );
};

export default Games;
